import React, { Component, memo } from "react";
import IO from "socket.io-client";
import {
  activityPolling,
  attendeeId,
  CheckValue,
  currentWorkoutTime,
  env,
  getAvailableUser,
  setCoach,
  setGym,
  setStaffInActivity,
  setUserInActivity,
  setWorkoutBuilder,
  UniqueID,
} from "../../services/CommonFunction";
import {
  playMemberStream,
  staffJoined,
  staffLeft,
  stopMemberStream,
  updateHeartRate,
  updateRanking,
} from "../NewCasting/SocketFun";
import Ongoing from "../NewCasting/Ongoing/Ongoing";
import { WaitingRoomScreen } from "../NewCasting/WaitingRoomScreen/WaitingRoomScreen";
import { staticVar } from "../../services/Constants";
import axios from "../../axios";
import ApiURL from "../../services/ApiURL";
import { modalService } from "../../services/subscriberService";
import { ErrorUI } from "../../components/UI/Modals/Modals";
import ZoomSDK from "../NewCasting/ZoomSDK/ZoomSDK";

class LiveActivity extends Component {
  constructor(props) {
    super(props);
    this.memberVideo = React.createRef();
    const onDemandData = {
      ...JSON.parse(localStorage.getItem("ondemandData")),
    };
    const workoutData = { ...JSON.parse(localStorage.getItem("workoutData")) };
    this.zoomRef = React.createRef();
    this.state = {
      socket: IO(env("OnDemandSocket") + localStorage.getItem("accessToken"), {
        transports: ["websocket"],
      }),
      totalSeconds: 0,
      required: {
        isHeartRateRequired: false,
        isLeaderBoardRequired: false,
      },
      staffsInActivity: {},
      coachData: {},
      gymData: {},
      allUsers: {},
      tagUsers: [],
      userActivityData: {},
      selfData: {},
      isInternetConnected: null,
      disconnectTime: 0,
      low_latency_mode: false,
      mute_participants_by_default: true,
      activityStatus: null,
      workoutData: { ...workoutData },
      ongoing: {
        ivsStatus: false,
        playBackURL: null,
        segmentDurations: [],
        started_at: undefined,
        start_datetime: undefined,
        total_activity_duration_in_seconds: 0,
      },
      ondemandData: { ...onDemandData },
      update: false,
      video_conference_data: null,
      themeColor: getComputedStyle(document.documentElement).getPropertyValue(
        "--theme-color"
      ),
      uid: new Date().toString() + UniqueID(),
      secondsSpentWatchingInCurrent: 0,
    };
  }

  get checkActivityStatus() {
    const { activityStatus } = this.state;
    return activityStatus === staticVar.waitingRoom
      ? staticVar.waiting
      : staticVar.roomStarted;
  }

  get memberVideos() {
    return this.memberVideo.current;
  }

  get memberVideosData() {
    if (this.memberVideos) {
      return this.memberVideos.getMemberVideoData;
    } else {
      return {
        constraints: {
          audio: { autoplay: true, deviceId: "" },
          video: { width: 1280, height: 720, deviceId: "" },
        },
        permissions: false,
        isCameraEnabled: false,
        videoId: "memberVideo",
        webRTCAdaptor: null,
      };
    }
  }

  get zoom() {
    return this.zoomRef.current;
  }

  get zoomData() {
    if (this.zoom) {
      return this.zoom.getZoomData;
    } else {
      return {
        sessionStatus: 0,
        OvCameraId: undefined,
        OvAudioId: undefined,
        activeSpeaker: null,
        videoTiles: {},
        audioInputDevices: [],
        audioOutputDevices: [],
        videoInputDevices: [],
        isCameraEnabled: false,
        isAudioEnabled: false,
        isLocalStreamStarted: false,
        constraints: {
          audio: { autoplay: true, deviceId: "" },
          video: { width: 1280, height: 720, deviceId: "" },
        },
      };
    }
  }

  componentDidMount() {
    this.joinActivity(true);
  }

  componentWillUnmount() {
    Object.keys(attendeeId).forEach((el) => {
      delete attendeeId[el];
    });
    if (CheckValue(this.state.socket)) {
      this.state.socket.disconnect();
    }
    clearInterval(this.myInterval);
    modalService.sendModalMessage({ status: false, data: null });
    this.callListners("off");
  }

  setSelfData = (data) => {
    const { userActivityData } = this.state;
    if (userActivityData.user_id === data.user_id) {
      this.setState({
        selfData: { ...data },
      });
    }
  };

  // Start Socket
  callListners = (status) => {
    this.socketEmitHandler();
    this.state.socket[status]("connect", this.socketConnected);
    this.state.socket[status]("disconnect", this.socketDisconnected);
    /*     this.state.socket[status]("sync_tagged_videos", this.tagged_videos)
    this.state.socket[status]("video_tagged", (e) => this.startStream(e, 1))
    this.state.socket[status]("video_untagged", (e) => this.endStream(e, 1))
 */ this.state.socket[status]("self_heartbeat_sync", this.selfHeartbeat);
    this.state.socket[status]("activity_ended", (e) =>
      this.endActivity(e, "activity_ended")
    );
    this.state.socket[status]("web_preview_off", (e) =>
      this.endActivity(e, "web_preview_off")
    );

    this.state.socket[status]("heartbeat", (e) =>
      updateHeartRate(e, this.state.allUsers)
    );
    // this.state.socket[status]("heart_rate_in_waiting", e => updateHeartRate(e, this.state.allUsers,this.state.selfHeartbeat,this.state.userActivityData));
    this.state.socket[status]("heart_rate_in_waiting", (e) =>
      updateHeartRate(e, this.state.allUsers, this.setSelfData)
    );
    this.state.socket[status]("rankings", (e) =>
      updateRanking(e, this.state.allUsers)
    );
    this.state.socket[status]("new_user", this.addNewUser);
    this.state.socket[status]("user_left", (e) => this.removeUser(e));
    this.state.socket[status]("waiting_room_ended", (e) =>
      this.endActivity(e, "waiting_room_ended")
    );
    this.state.socket[status]("user_removed", (e) => this.forceRemove(e));
    this.state.socket[status]("mute_unmute_participant", (e) => {
      console.log(e);
      if (
        this.zoom &&
        (!e.user_activity_session_id ||
          e.user_activity_session_id ===
            this.state.userActivityData.user_activity_session_id) &&
        !this.zoom.getLocalMuteStatus()
      ) {
        this.zoom.enableDisableAudioCamera("audio");
      }
    });
    this.state.socket[status]("activity_started", this.startActivity);
    this.state.socket[status]("live_stream_ended", this.setStream);
    this.state.socket[status]("live_stream_started", this.setStream);
    this.state.socket[status]("publish_stream_started", (e) => {
      if (!this.state.low_latency_mode) {
        playMemberStream(e, this.state.allUsers, this.state.userActivityData);
      }
    });
    this.state.socket[status]("publish_stream_stopped", (e) => {
      if (!this.state.low_latency_mode) {
        stopMemberStream(e, this.state.allUsers, this.stateSet);
      }
    });
    this.state.socket[status]("staff_joined", (e) =>
      staffJoined(e, this.state.staffsInActivity)
    );
    this.state.socket[status]("staff_left", (e) =>
      staffLeft(e, this.state.staffsInActivity)
    );
  };

  socketConnected = () => {
    this.socketEmitHandler();
  };

  tagged_videos = (data) => {
    if (data.tagged_user_session_ids && data.tagged_user_session_ids.length) {
      data.tagged_user_session_ids.forEach((el) => {
        Object.values(this.state.allUsers).forEach((element) => {
          if (
            el.user_activity_session_id === element.user_activity_session_id &&
            !element.me
          ) {
            this.startStream(
              { ...element, tagged_user_id: element.user_id },
              1
            );
          }
        });
      });
    }
  };

  socketEmitHandler = () => {
    let temp = {
      activity_id: this.state.userActivityData.activity_id,
      user_id: this.state.userActivityData.user_id,
      user_activity_session_id:
        this.state.userActivityData.user_activity_session_id,
    };
    console.log("socketEmitHandler", temp);
    this.state.socket.emit("subscribe_activity", temp, () => {
      if (!this.state.isInternetConnected) {
        this.setState({
          isInternetConnected: true,
        });
      }
    });
  };

  socketDisconnected = (reason) => {
    this.setState({
      isInternetConnected: false,
      disconnectTime: this.state.totalSeconds,
    });
    if (reason === "io server disconnect") {
      // the disconnection was initiated by the server, you need to reconnect manually
      this.state.socket.connect();
    }
  };

  addNewUser = (data) => {
    const { allUsers, activityStatus } = this.state;
    console.log(data);
    if (allUsers.hasOwnProperty(data.user_id)) {
      if (
        allUsers[data.user_id].me &&
        allUsers[data.user_id].device_type === "WEB" &&
        allUsers[data.user_id].device_id === this.state.device_id
      ) {
        this.endActivity(undefined, "addNewUser");
      } else {
        // allUsers[data.user_id]['color'] = '#808080';
        // allUsers[data.user_id]['opacity'] = 'unset';
        allUsers[data.user_id]["heartrate"] = 0;
        allUsers[data.user_id]["user_status_in_activity"] =
          this.checkActivityStatus;
        allUsers[data.user_id]["isVideoStarted"] = false;
        let pinnedUserIDs = JSON.parse(localStorage.getItem("pinnedUserIDs"));
        if (
          pinnedUserIDs &&
          pinnedUserIDs.length &&
          pinnedUserIDs.includes(data.user_id)
        ) {
          setTimeout(() => {
            this.userPin(data.user_id);
          }, 100);
        }
      }
    } else {
      allUsers[data.user_id] = {
        ...data,
        // color: '#808080',
        maxHeartRate: Math.round(208 - 0.7 * data["age"]),
        calories_burnt: 0,
        // opacity: 'unset',
        heartrate: 0,
        muted: true,
        isVideoStarted: false,
        user_status_in_activity: this.checkActivityStatus,
      };
      const temp = Object.values(attendeeId).findIndex(
        (el) => el === data.user_id
      );
      if (temp >= 0) {
        const keys = Object.keys(attendeeId);
        allUsers[data.user_id].presentAttendeeId = keys[temp];
      }
    }
  };

  removeUser = (data, force = false) => {
    console.log("force", force);
    const { allUsers, tagUsers, activityStatus } = this.state;
    if (allUsers.hasOwnProperty(data.user_id)) {
      if (activityStatus === staticVar.waitingRoom || force) {
        if (allUsers[data.user_id].me) {
          this.endActivity(undefined, "removeUser");
        } else {
          const index = tagUsers.findIndex((el) => el.user_id === data.user_id);
          if (index > -1) {
            tagUsers.splice(index, 1);
          }
          delete attendeeId[allUsers[data.user_id].presentAttendeeId];
          delete allUsers[data.user_id];
        }
      } else {
        if (allUsers[data.user_id].me) {
          this.endActivity(undefined, "removeUser");
        } else {
          // allUsers[data.user_id]['color'] = '#808080';
          // allUsers[data.user_id]['opacity'] = '0.6';
          allUsers[data.user_id]["max_heart_rate_percent"] = 0;
          allUsers[data.user_id]["heartrate"] = 0;
          allUsers[data.user_id]["user_status_in_activity"] = "ENDED";
          allUsers[data.user_id]["video_stream"] = false;
          this.endStream(allUsers[data.user_id], true);
        }
      }
    }
  };

  forceRemove = (data) => {
    const { allUsers } = this.state;
    if (allUsers[data.user_id].me) {
      ErrorUI("You have been removed from the class.", null, {}, () =>
        this.endActivity(data, "user_removed")
      );
    } else {
      this.removeUser(data, true);
    }
  };

  endActivity = async (data, status = true) => {
    console.log("endActivity", status, data);
    const is10Percent =
      (parseInt(this.state.userActivityData.seconds_spent_watching) +
        this.state.secondsSpentWatchingInCurrent) /
        this.state.totalSeconds >
      0.1;
    console.log(is10Percent);
    if (
      status !== "skip" &&
      this.state.activityStatus === staticVar.roomStarted &&
      this.state.userActivityData &&
      this.state.totalSeconds &&
      !is10Percent
    ) {
      ErrorUI(
        "This workout will not be saved to your workout history.",
        null,
        {},
        () => {
          this.endActivity(null, "skip");
        }
      );
      return;
    }

    if (this.memberVideos) {
      await this.memberVideos.stopStream();
    }
    this.setState((prevState) => ({
      ongoing: {
        ...prevState.ongoing,
        ivsStatus: false,
        playBackURL: null,
      },
    }));
    if (CheckValue(data) && data.in_hangout_room && is10Percent) {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      //this.setState({ activityStatus: staticVar.hangoutRoom })
      return;
    }
    localStorage.removeItem("workoutData");
    localStorage.removeItem("isCameraEnable");
    localStorage.removeItem("pinnedUserIDs");

    let temp = {
      activity_id: this.state.userActivityData.activity_id,
      user_id: this.state.userActivityData.user_id,
    };
    if (CheckValue(this.state.socket)) {
      this.state.socket.emit("unsubscribe_activity", temp, () => {});
    }

    // stopMediaTrack({ audio: { autoplay: true, deviceId: '' }, video: { width: 1280, height: 720, deviceId: '' } });
    setTimeout(() => {
      axios
        .post(ApiURL._leaveActivity, {
          user_activity_session_id:
            this.state.userActivityData.user_activity_session_id,
        })
        .then((res) => {
          console.log(res);
        })
        .catch((reason) => {
          console.log(reason);
        });
      // console.log('testHO');
      if (status === "activity_ended") {
        // if (status === "activity_ended" && is10Percent) {
        this.props.history.push(
          `/ClassSummary/${this.state.userActivityData.activity_id}/${
            this.state.userActivityData.user_activity_session_id
          }/${false}`
        );
        // console.log(is10Percent);
      } else {
        // const is10Percent2 =
        //   parseInt(this.state.secondsSpentWatchingInCurrent) / this.state.totalSeconds * 10000;
        // console.log(is10Percent2);
        // console.log(this.state.totalSeconds);
        // console.log(this.state.secondsSpentWatchingInCurrent / this.state.totalSeconds);
        // console.log(this.state.secondsSpentWatchingInCurrent / this.state.totalSeconds > 0.1);
        // console.log(this.state.userActivityData.seconds_spent_watching);
        this.props.history.push("/Home");
      }
    }, 1000);
  };

  stopStreaming = async (id = "videoElement") => {
    var videoElem = document.getElementById(id);
    const stream = videoElem.srcObject;
    if (stream === null) {
      return;
    }
    const tracks = stream.getTracks();
    videoElem.srcObject = null;
    await tracks.forEach(function (track) {
      track.stop();
    });
  };

  startActivity = async (data) => {
    const { allUsers } = this.state;
    await Object.values(allUsers).forEach((el) => {
      if (!this.state.low_latency_mode) {
        delete el.stream;
        delete el["tileId"];
        el.video_stream = false;
      } else if (el.isVideoStarted) {
        this.zoom.stopAttendeeVideo(el.userId);
      }
    });
    this.setState((prevState) => ({
      // allUsers: allUsers,
      activityStatus: staticVar.roomStarted,
      totalSeconds: 0,
      ongoing: {
        ...prevState.ongoing,
        started_at: data.started_at
          ? data.started_at
          : new Date().toISOString(),
      },
    }));
  };

  startStream = (data, status) => {
    const { allUsers, tagUsers, userActivityData, socket } = this.state;
    let userId = data.tagged_user_id;
    if (allUsers[userId] && allUsers[userId].me) {
      return;
    }
    if (!status) {
      userId = data.user_id;
      if (allUsers[userId]) {
        allUsers[userId].showStream = true;
        this.setState({
          allUsers: allUsers,
        });
      }
      const tagData = {
        user_id: userActivityData.user_id,
        user_activity_session_id: userActivityData.user_activity_session_id,
        activity_id: data.activity_id,
        tagged_user_id: data.user_id,
        tagged_user_activity_session_id: data.user_activity_session_id,
      };
      //      socket.emit("video_tagged", tagData, (obj) => {})
    }
    if (allUsers.hasOwnProperty(userId)) {
      allUsers[userId].showStream = true;
    }
    const temp = tagUsers.findIndex((el) => el.user_id === userId);
    if (temp < 0) {
      tagUsers.push({ ...allUsers[userId] });
    } else {
      tagUsers[temp] = { ...allUsers[userId] };
    }
  };

  // End Socket

  update = () => this.setState((prevState) => ({ update: !prevState.update }));

  endStream = (data, status) => {
    const {
      allUsers,
      tagUsers,
      userActivityData,
      socket,
      activityStatus,
      low_latency_mode,
    } = this.state;
    let userId = data.tagged_user_id || data.user_id;
    if (allUsers.hasOwnProperty(userId) && allUsers[userId].me) {
      return;
    }
    if (allUsers.hasOwnProperty(userId)) {
      if (activityStatus === staticVar.roomStarted) {
        if (low_latency_mode) {
        } else {
          if (allUsers[userId].stream) {
            allUsers[userId].stream.stop(
              data.tagged_user_activity_session_id ||
                data.user_activity_session_id
            );
            delete allUsers[userId].stream;
          }
        }
        allUsers[userId].isVideoStarted = false;
      }
      allUsers[userId].showStream = false;
    }

    const index = tagUsers.findIndex((el) => el.user_id === userId);
    if (index > -1) {
      tagUsers.splice(index, 1);
      this.setState({
        tagUsers: tagUsers,
      });
    }

    if (!status) {
      const tagData = {
        user_id: userActivityData.user_id,
        user_activity_session_id: userActivityData.user_activity_session_id,
        activity_id: data.activity_id,
        tagged_user_id: data.user_id,
        tagged_user_activity_session_id: data.user_activity_session_id,
      };
      //    socket.emit("video_untagged", tagData, (obj) => {})
    }
  };

  syncSocketEmitHandler = (data) => {
    //this.state.socket.emit("sync_tagged_videos", data, (obj) => {})
  };

  selfHeartbeat = (data) => {
    this.setState({
      selfData: {
        maxHeartRatePercent: data.max_of_max_heart_rate_percent,
        maxheartrate: data.max_heart_rate,
        heartrate: data.current_heart_rate,
        calories_burnt: data.calories_burnt,
        max_heart_rate_percent: data.max_heart_rate_percent,
      },
    });
  };

  setStream = (data) => {
    if (CheckValue(data.playbackUrl)) {
      this.setState((prevState) => ({
        ongoing: {
          ...prevState.ongoing,
          ivsStatus: true,
          playBackURL: data.playbackUrl,
        },
      }));
    } else {
      this.setState((prevState) => ({
        ongoing: {
          ...prevState.ongoing,
          ivsStatus: false,
        },
      }));
    }
  };

  // End Socket

  joinActivity = (first = false) => {
    const { workoutData, staffsInActivity, ongoing, ondemandData, socket } =
      this.state;
    axios
      .post(ApiURL._joinActivityV3, {
        activity_id: workoutData.activity_id,
        video_platform: "ZOOM",
        device_type: "WEB",
        device_id: this.state.uid,
      })
      .then(
        async (response) => {
          console.log(response);
          const data = response.data.data;
          if (data.activity_status === staticVar.ended) {
            this.clear();
            return;
          }
          await setStaffInActivity(data, staffsInActivity);
          if (
            CheckValue(data.playback_url) &&
            CheckValue(data.stream_key_arn)
          ) {
            ongoing.ivsStatus = true;
            ongoing.playBackURL = data.playback_url;
          }
          if (data.workout_builder && data.workout_builder.length) {
            await setWorkoutBuilder(data, currentWorkoutTime(data.started_at));
            ongoing.segmentDurations = [...data.workout_builder];
          }
          await this.setState((prevState) => ({
            coachData: setCoach(data),
            showSeekBar: true,
            allUsers: { ...prevState.allUsers, ...setUserInActivity(data) },
            ongoing: {
              ...prevState.ongoing,
              started_at: data.started_at,
              start_datetime: data.start_datetime,
              total_activity_duration_in_seconds:
                data.total_activity_duration_in_seconds,
            },
            required: {
              isHeartRateRequired: data.heartrate_required,
              isLeaderBoardRequired: data.leaderboard_type,
            },
            userActivityData: { ...data.user_activity_data },
            gymData: setGym(data),
            low_latency_mode: data.low_latency_mode,
            mute_participants_by_default: data.mute_participants_by_default,
            userType: localStorage.getItem("userType") || "everyone",
            activityStatus: data.activity_status,
            video_conference_data: data.video_conference_object,
            totalSeconds: this.getTime(data.activity_status, {
              started_at: data.started_at,
              start_datetime: data.start_datetime,
            }),
            /* socket: IO(
              env("OnDemandSocket") + localStorage.getItem("accessToken"),
              { transports: ["websocket"] }
            ), */
          }));
          if (first) {
            this.startTimer();
            setTimeout(() => {
              this.callListners("on");
            }, 1000 * 0.5);
          }
          let pinnedUserIDs = JSON.parse(localStorage.getItem("pinnedUserIDs"));
          if (pinnedUserIDs && pinnedUserIDs.length) {
            pinnedUserIDs.map((id) => {
              setTimeout(() => {
                this.userPin(id);
              }, 100);
            });
          } else {
            pinnedUserIDs = [];
            localStorage.setItem(
              "pinnedUserIDs",
              JSON.stringify(pinnedUserIDs)
            );
          }
        },
        async (error) => {
          console.log(error);
          setTimeout(() => {
            if (CheckValue(this.state.socket)) {
              this.state.socket.disconnect();
            }
          }, 200);
          this.clear();
        }
      );
  };

  clear = () => {
    localStorage.removeItem("workoutData");
    localStorage.removeItem("userType");
    localStorage.removeItem("pinnedUserIDs");
    //localStorage.removeItem("accessToken");
    this.props.history.push("/Home");
  };

  startTimer = () => {
    this.myInterval = setInterval(() => {
      this.setState((prevState) => ({
        totalSeconds: this.getTime(prevState.activityStatus, prevState.ongoing),
        secondsSpentWatchingInCurrent:
          prevState.activityStatus === staticVar.roomStarted
            ? prevState.secondsSpentWatchingInCurrent + 1
            : 0,
      }));
      this.setState(() => ({
        seconds_spent_watching: this.state.secondsSpentWatchingInCurrent,
      }));
    }, 1000);
  };

  getTime = (activityStatus, ongoing) => {
    let totalSeconds = 0;
    if (activityStatus === staticVar.roomStarted) {
      totalSeconds = currentWorkoutTime(ongoing.started_at, 1);
    } else {
      totalSeconds = currentWorkoutTime(ongoing.start_datetime, 0);
    }
    return totalSeconds;
  };

  stateSet = (obj) => {
    this.setState(obj);
  };

  userPin = (id) => {
    const { allUsers, low_latency_mode } = this.state;
    if (allUsers.hasOwnProperty(id) && !allUsers[id].me) {
      let pinnedUserIDs = JSON.parse(localStorage.getItem("pinnedUserIDs"));
      if (allUsers[id].showStream) {
        this.endStream(allUsers[id], 0);
        pinnedUserIDs = pinnedUserIDs.filter((e) => e !== id);
      } else {
        const { allUsersArr } = getAvailableUser(allUsers, "all");
        const length = allUsersArr.filter((el) => el.showStream).length;
        let allowedUsers = 4;
        if (this.props.activityStatus === staticVar.roomStarted) {
          allowedUsers = 4;
        }
        if (length <= allowedUsers) {
          this.startStream(allUsers[id], 0);
          if (!pinnedUserIDs.includes(id)) {
            pinnedUserIDs.push(id);
          }
        } else {
          ErrorUI("You can pin up to 3 people.");
        }
      }
      localStorage.setItem("pinnedUserIDs", JSON.stringify(pinnedUserIDs));
    }
  };

  handleLeaveClick = () => {
    console.log("Leave Meeting");
    const text =
      this.state.activityStatus === staticVar.roomStarted
        ? "class"
        : this.state.activityStatus === staticVar.waitingRoom
        ? "waiting room"
        : "hangout room";
    ErrorUI(
      "Are you sure you want to leave this " + text + "?",
      () => this.endActivity(undefined, false).then((r) => {}),
      {
        cancelText: "Cancel",
        submitText: "Leave",
      }
    );
  };

  get isWaitingRoom() {
    return this.state.activityStatus === staticVar.waitingRoom;
  }
  get isHangoutRoom() {
    return this.state.activityStatus === staticVar.hangoutRoom;
  }
  get isOngoingRoom() {
    return this.state.activityStatus === staticVar.roomStarted;
  }
  render() {
    const canvas = <CanvasUI />;
    const {
      activityStatus,
      low_latency_mode,
      socket,
      allUsers,
      coachData,
      stateSet,
      id,
      userActivityData,
      video_conference_data,
      mute_participants_by_default,
    } = this.state;
    const temp = {
      ...this.state,
      userPin: this.userPin,
      startStream: this.startStream,
      stateSet: this.stateSet,
      endStream: this.endStream,
      leaveMeeting: this.handleLeaveClick,
      canvas,
    };
    return (
      <React.Fragment>
        {activityStatus === staticVar.waitingRoom ||
        activityStatus === staticVar.hangoutRoom ||
        low_latency_mode ? (
          <ZoomSDK
            socket={socket}
            ref={this.zoomRef}
            allUsers={allUsers}
            coachData={coachData}
            clas="participants-canvas"
            stateSet={stateSet}
            id={id}
            userActivityData={userActivityData}
            video_conference_data={video_conference_data}
            streamControlsHandler={this.streamControlsHandler}
            activity_status={activityStatus}
            isWaitingRoom={this.isWaitingRoom}
            isOngoingRoom={this.isOngoingRoom}
            isHangoutRoom={this.isHangoutRoom}
          />
        ) : null}

        {activityStatus === staticVar.waitingRoom ||
        activityStatus === staticVar.hangoutRoom ? (
          <WaitingRoomScreen
            zoom={this.zoom}
            zoomData={this.zoomData}
            {...temp}
          />
        ) : null}
        {activityStatus === staticVar.roomStarted ? (
          <Ongoing
            zoom={this.zoom}
            zoomData={this.zoomData}
            memberVideo={this.memberVideo}
            memberVideos={this.memberVideos}
            memberVideosData={this.memberVideosData}
            low_latency_mode={low_latency_mode}
            mute_participants_by_default={mute_participants_by_default}
            {...temp}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

export default LiveActivity;

const CanvasUI = memo(() => (
  <canvas
    id="coach_canvas_view"
    className={`${"WRCoachVideo"}`}
    width="1920"
    height="1080"
  ></canvas>
));
